export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB-7ibF8bB0qCrYUdnLBvtI8fACzFbFxV4",
    authDomain: "ocdr-staging.firebaseapp.com",
    databaseURL: "https://ocdr-staging.firebaseio.com",
    projectId: "ocdr-staging",
    storageBucket: "ocdr-staging.appspot.com",
    messagingSenderId: "127064843699",
    appId: "1:127064843699:web:c4fa221f64105b423d97c6",
  },
  apiUrl: "https://us-central1-ocean-cdr.cloudfunctions.net/api-staging",
};
